import { dialogTexts } from "@features/faqs/constants";
import GlobalPodcastPlayer from "@features/podcasts/components/GlobalPodcastPlayer";
import QAChatWrapper from "@features/session/components/QASearch/QAChatWrapper";
import { isWeb } from "@helpers/platform";
import { useAppStore } from "@hooks/useAppStore";
import useAuthUser from "@hooks/useAuthUser";

import { useDevice } from "@hooks/useDevice";

import Box from "@memorang/ui/components/Box";
import ModalHeader from "components/ModalHeader";
import { Redirect, Stack, usePathname } from "expo-router";
import { t } from "i18next";

export default function Layout() {
	const { isSignedIn, isLoaded } = useAuthUser();

	const pathname = usePathname();
	const { isIpad } = useDevice();

	const purchaseSchema = useAppStore((state) => state.app?.purchase);

	if (isLoaded && !isSignedIn && pathname !== "/redeem") {
		return <Redirect href={"/(auth)/login"} />;
	}

	const modalVariant = isIpad
		? ("containedModal" as const)
		: ("modal" as const);

	return (
		<Box flex={1} flexDirection="row" justifyContent="space-between">
			<Stack
				screenOptions={{
					headerShown: false,
					contentStyle: {
						flex: 1,
					},
				}}
			>
				<Stack.Screen
					name="purchase/index"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								headerTitle={purchaseSchema?.paywall?.title || "Purchase"}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="session/customize"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle={t("sessionConfig.title")}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="suggestcorrection"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="faqs"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle={t(dialogTexts.faqs.title)}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="info"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="profile/change-avatar"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle="Choose your avatar"
							/>
						),
					}}
				/>
				<Stack.Screen
					name="feedback"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="exams"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="aila/[itemId]"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
			</Stack>
			{isWeb && <QAChatWrapper />}
			<GlobalPodcastPlayer />
		</Box>
	);
}
